import { render } from "./SectionsDiscounts.vue?vue&type=template&id=d18b6b9a&scoped=true"
import script from "./SectionsDiscounts.vue?vue&type=script&lang=js"
export * from "./SectionsDiscounts.vue?vue&type=script&lang=js"

import "./SectionsDiscounts.vue?vue&type=style&index=0&id=d18b6b9a&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18b6b9a"]])

export default __exports__